import {Component} from "@angular/core";
import {ModalDialogConfiguration} from "@cupoui/shared/model/modal/modal-dialog-configuration";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {SERVER_API_URL} from "../../../app.constants";
import {fromFetch} from "rxjs/internal/observable/dom/fetch";
import {mergeMap} from "rxjs/operators";
import {from, Subscription} from "rxjs";
import {UntilDestroy} from "@ngneat/until-destroy";

@UntilDestroy({checkProperties: true})
@Component({
    selector: 'app-pdf-stream-modal',
    templateUrl: './pdf-stream-modal.component.html',
    styleUrls: ['./pdf-stream-modal.component.scss'],
    standalone: false
})
export class PdfStreamModalComponent {
  modalDialogConfiguration: ModalDialogConfiguration;
  private readonly videoServerStreamUrl = `${SERVER_API_URL}video/stream/`;
  private stream$: Subscription;

  pdfUrl: string;

  constructor(public activeModal: NgbActiveModal) {}

  init(header: string, howToLoginVideoUrl: string, howToLoginVideoPosterUrl: string): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      headerText: header
    });
    this.stream$ = fromFetch(`${this.videoServerStreamUrl}${howToLoginVideoUrl}`)
      .pipe(mergeMap(response => from(response.blob())))
      .subscribe(blob => {this.pdfUrl = URL.createObjectURL(blob)});
  }
}
